export const DISTENTION_EMAILS = ['locatorpro@e100.eu'];
